import React from 'react';
import { useParams } from 'react-router-dom'; // URL parametresini almak için hook
import { gql, useQuery } from '@apollo/client';

// Belirli bir slug'a göre tek bir yazıyı çekmek için GraphQL sorgusu
// Bu sorgu bir 'slug' değişkeni alacak şekilde tanımlanmalı
const GET_POST_BY_SLUG = gql`
  query GetPostBySlug($slug: ID!) { # Değişkeni tanımla ($slug), tipi ID! veya String! olabilir (WPGraphQL şemana bağlı)
    post(id: $slug, idType: SLUG) { # idType: SLUG diyerek slug ile arama yapacağımızı belirtiyoruz
      id
      title
      content # Yazı içeriğini çek
      date
      featuredImage { # Öne çıkan görseli iste
        node {
          sourceUrl # Görselin tam URL'si
          altText # Alternatif metin (SEO ve erişilebilirlik için önemli)
        }
      }
      # İhtiyacın olan diğer alanları buraya ekleyebilirsin (featuredImage, author vb.)
    }
  }
`;

function SinglePost() {
  // useParams hook'u ile URL'deki dinamik parametreleri alıyoruz
  // App.js'de <Route path="/yazi/:slug" ...> dediğimiz için { slug: 'değer' } şeklinde gelir
  const { slug } = useParams();

  // useQuery'yi çağırırken variables seçeneği ile sorguya değişken gönderiyoruz
  const { loading, error, data } = useQuery(GET_POST_BY_SLUG, {
    variables: { slug }, // URL'den alınan slug'ı sorguya değişken olarak gönder
  });

  if (loading) return <p>Yazı yükleniyor...</p>;
  if (error) {
    console.error("Tekil Yazı Hata:", error);
    return <p>Hata oluştu: {error.message}. Böyle bir yazı bulunamadı veya bir sorun oluştu.</p>;
  }

  // Veri gelmişse ve post verisi varsa göster
  if (!data || !data.post) return <p>Yazı bulunamadı.</p>;

  const { post } = data;

  return (
    <article>
      <h1>{post.title}</h1>
      <p><small>Yayınlanma Tarihi: {new Date(post.date).toLocaleDateString()}</small></p>

      {/* Öne çıkan görseli göster (eğer varsa) */}
      {post.featuredImage && post.featuredImage.node && (
        <img
          src={post.featuredImage.node.sourceUrl}
          alt={post.featuredImage.node.altText || post.title} // Alt metin yoksa başlığı kullan
          style={{ maxWidth: '100%', height: 'auto', marginBottom: '20px' }} // Basit stil ekleyelim
        />
      )}

      {/* WP'den gelen HTML içeriğini güvenli bir şekilde render etmek için dangerouslySetInnerHTML kullanılır */}
      {/* Dikkat: Bu içeriğin güvenilir bir kaynaktan geldiğinden emin olmalısın (kendi WP siten) */}
      <div dangerouslySetInnerHTML={{ __html: post.content }} />
    </article>
  );
}

export default SinglePost;